module.exports = __webpack_public_path__ + "assets/img/media_30.6d1741ce.png";